/** Preserve login MFA anchor: factor select/resend must not extend past login anchor. */
export function resolveLoginMfaExpiry(
  baseExpiresAt?: number,
  updateExpiresAt?: number,
  loginAnchorExpiresAt?: number,
): number | undefined {
  if (loginAnchorExpiresAt != null) {
    if (updateExpiresAt != null) {
      return Math.min(updateExpiresAt, loginAnchorExpiresAt);
    }
    if (baseExpiresAt != null) {
      return Math.min(baseExpiresAt, loginAnchorExpiresAt);
    }
    return loginAnchorExpiresAt;
  }

  if (baseExpiresAt != null && updateExpiresAt != null) {
    return Math.min(updateExpiresAt, baseExpiresAt);
  }

  return updateExpiresAt ?? baseExpiresAt;
}

export function pickLoginMfaExpiryBase(
  contextExpiresAt?: number,
  storeExpiresAt?: number,
  loginAnchorExpiresAt?: number,
): number | undefined {
  return contextExpiresAt ?? storeExpiresAt ?? loginAnchorExpiresAt;
}
